"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _ThemeProvider = require("./ThemeProvider");
var _ElementChildren = require("./ElementChildren");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["min", "now", "max", "label", "visuallyHidden", "striped", "animated", "className", "style", "variant", "bsPrefix"],
  _excluded2 = ["isChild"],
  _excluded3 = ["min", "now", "max", "label", "visuallyHidden", "striped", "animated", "bsPrefix", "variant", "className", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }
  var error = null;
  React.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */
    var element = /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressBar, {});
    if (child.type === element.type) return;
    var childType = child.type;
    var childIdentifier = /*#__PURE__*/ /*#__PURE__*/React.isValidElement(child) ? childType.displayName || childType.name || childType : child;
    error = new Error("Children of ".concat(componentName, " can contain only ProgressBar ") + "components. Found ".concat(childIdentifier, "."));
  });
  return error;
}
function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}
function renderProgressBar(_ref, ref) {
  var min = _ref.min,
    now = _ref.now,
    max = _ref.max,
    label = _ref.label,
    visuallyHidden = _ref.visuallyHidden,
    striped = _ref.striped,
    animated = _ref.animated,
    className = _ref.className,
    style = _ref.style,
    variant = _ref.variant,
    bsPrefix = _ref.bsPrefix,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    role: "progressbar",
    className: (0, _classnames.default)(className, "".concat(bsPrefix, "-bar"), _defineProperty(_defineProperty(_defineProperty({}, "bg-".concat(variant), variant), "".concat(bsPrefix, "-bar-animated"), animated), "".concat(bsPrefix, "-bar-striped"), animated || striped)),
    style: _objectSpread({
      width: "".concat(getPercentage(now, min, max), "%")
    }, style),
    "aria-valuenow": now,
    "aria-valuemin": min,
    "aria-valuemax": max,
    children: visuallyHidden ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "visually-hidden",
      children: label
    }) : label
  }));
}
var ProgressBar = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$isChild = _ref2.isChild,
    isChild = _ref2$isChild === void 0 ? false : _ref2$isChild,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var props = _objectSpread({
    min: 0,
    max: 100,
    animated: false,
    visuallyHidden: false,
    striped: false
  }, rest);
  props.bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(props.bsPrefix, 'progress');
  if (isChild) {
    return renderProgressBar(props, ref);
  }
  var min = props.min,
    now = props.now,
    max = props.max,
    label = props.label,
    visuallyHidden = props.visuallyHidden,
    striped = props.striped,
    animated = props.animated,
    bsPrefix = props.bsPrefix,
    variant = props.variant,
    className = props.className,
    children = props.children,
    wrapperProps = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    ref: ref
  }, wrapperProps), {}, {
    className: (0, _classnames.default)(className, bsPrefix),
    children: children ? (0, _ElementChildren.map)(children, function (child) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        isChild: true
      });
    }) : renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      visuallyHidden: visuallyHidden,
      striped: striped,
      animated: animated,
      bsPrefix: bsPrefix,
      variant: variant
    }, ref)
  }));
});
ProgressBar.displayName = 'ProgressBar';
var _default = exports.default = ProgressBar;